import React from 'react';
import './Classes.css';
import GeneralClassImg from '../assets/images1/GeneralClass.jpg';
import KidsClassImg from '../assets/images1/Kids.jpg';
import MixedClassImg from '../assets/images1/MixedClass.jpg';

const Classes = () => {
  return (
    <section id="classes" className="classes-section">
    <h2>Classes</h2>
    <div className="classes">
      <div className="class-item">
        <div className="class-info">
          <h3>Junior Kyokushin Karate</h3>
          <p>Perfect for younger participants new to martial arts. Learn the basics of Kyokushin Karate.</p>
          <p>Mount Gambier: Monday 4:45pm-5:45pm</p>
          <p>Allendale: Tuesday 6:00pm-6:40pm</p>
          <p>Millicent: Wednesday 5:30pm-6:15pm</p>
        </div>
        <img src={KidsClassImg} alt="General Kyokushin Karate" className="class-image" />
        
      </div>

      <div className="class-item">
        <div className="class-info">
          <h3>General Kyokushin Karate</h3>
          <p>For adults and teens practitioners or younger ones who have been training for some time. Higher intensity, advanced techniques and sparring.</p>
          <p>Mount Gambier: Monday 6:00pm-7:30pm</p>
          <p>Allendale: Tuesday 6:45pm-7:30pm</p>
          <p>Millicent: Monday 6:00pm-7:30pm</p>
          <p>Millicent: Wednesday 6:30pm-8:00pm</p>
          
        </div>
        <img src={GeneralClassImg} alt="General Kyokushin Karate" className="class-image" />
      </div>

      <div className="class-item">
        <div className="class-info">
          <h3>Open Class Kyokushin Karate</h3>
          <p>A less structured class, focusing more on fitness and bag work</p>
          <p>Also used to work on specific areas for gradings or tournaments</p>
          <p>Millicent: Friday 6:00pm-7:30pm</p>
        </div>
        <img src={MixedClassImg} alt="Kids Kyokushin Karate" className="class-image" />
      </div>
    </div>
    </section>
  );
};

export default Classes;
